window.loadImage = require('blueimp-load-image');
var _ = require('underscore');
var scriptData = require('./script_data.js');

module.exports = {
  downsample: downsample
};

/**
 * Downsample image so we can leverage client instead of sending huge bytes to the server
 *
 * Reports errors back to the controller if resulted byte size is greater than allowed size
 * or file type is not allowed
 *
 * @param file
 * @param allowedFileSize
 * @param allowedFileTypes
 * @param successCallback
 * @param errorCallback
 */
function downsample(file,
                    allowedFileSize,
                    allowedFileTypes,
                    successCallback,
                    errorCallback) {
  var i18n = scriptData.getData('/visual_search/i18n');

  if (!_.includes(allowedFileTypes, file.type)) {
    errorCallback({
      metric: {
        name: 'typekit.render.visual-search.error-message',
        value: {error: 'format', format: file.type}
      },

      errorMessage: i18n.image_downsampler.file_format_not_supported
    });

    return;
  }

  window.loadImage(
    file,
    function(canvas) {
      if (canvas.type === 'error') {
        errorCallback({
          metric: {
            name: 'typekit.render.visual-search.error-message',
            value: {error: 'unprocessable'}
          },

          errorMessage: i18n.image_downsampler.file_could_not_be_processed
        });

        return;
      }

      var base64String = canvas.toDataURL(file.type);

      if (_byteSize(base64String) > allowedFileSize) {
        errorCallback({
          metric: {
            name: 'typekit.render.visual-search.error-message',
            value: {error: 'size', size: file.size}
          },

          errorMessage: i18n.image_downsampler.file_is_too_large
        });
      } else {
        successCallback(base64String, file.name);
      }
    },
    {
      pixelRatio: 1,
      downsamplingRatio: 0.5,
      maxWidth: 4000, // if you set width and height to 5000, you get an error message that it exceeds canvas size of 16M
      maxHeight: 4000,
      minWidth: 1,
      minHeight: 1,
      canvas: true,
      orientation: true
    }
  );
}

function _byteSize(base64String) {
  return Math.round(base64String.length * 3 / 4); // eslint-disable-line no-magic-numbers
}
